import { instance } from '../../config/intercepter';

export const getOrdersFn = async () => {
  const response = await instance.get(`api/orders`);
  return response.data;
};

export const getOrderByIdFn = async (orderId) => {
  const response = await instance.get(`api/orders/${orderId}`);
  return response.data;
};

export const getCustomerFormFields = async (customerCode) => {
  const response = await instance.get(`api/customerformrequiredfields/${customerCode}`);
  return response.data;
};

export const getOrderStepsFn = async (orderId) => {
  const response = await instance.get(`api/ordersteps`);
  return response.data;
};

export const addOrdersPaymentFn = async (payload) => {
  const response = await instance.post(`api/order/${payload.cncode}/payment`,payload.data);
  return response.data;
};

export const addStandingOrdersFn = async (payload) => {
  const response = await instance.post(`api/order/${payload.cncode}/standingorder`, payload.data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  },);
  return response.data;
};

//rename func
export const addAcceptOrdersFn = async (cncode) => {
  const response = await instance.post(`api/order/${cncode}/accept`);
  return response.data;
};

//rename func
export const getDocumentFn = async (cncode, docid) => {
  const response = await instance.get(`api/orders/${cncode}/file/${docid}`);
  return response.data;
};

//rename func
export const getOrderConfirmationFn = async (cncode) => {
  const response = await instance.get(`api/orders/${cncode}/overallsubmit`);
  return response.data;
};

//rename func, todo post method
export const getPreferenceFormFn = async (cncode) => {
  const response = await instance.get(`api/orders/${cncode}/preferencesform`);
  return response.data;
};

export const saveCustomerFormFn = async (payload) => {
  const response = await instance.post(`api/orders/${payload.cncode}/savecustomerform`,payload.data);
  return response.data;
};
